export const protocol_questions = {
  edit: {
    history: {
      title: "Historial de cambios del protocolo",
      changed_by: "Cambiado por",
      changed_at: "Cambiado en",
    },
    viewing_local_changes: "Estás viendo cambios locales.",
    viewing_live_version: "Estás viendo la versión en vivo.",
    clear_local_changes: "Limpiar cambios locales",
    other_protocol_questions_linked_to_the_requirement: "Otras preguntas de protocolo vinculadas a este requisito",
    no_other_protocol_questions_linked_to_the_requirement:
      "No hay otras preguntas de protocolo vinculadas a este requisito",
    interlink_questions: "Interconectar preguntas",
    save_links: "Guardar enlaces",
  },
  back_to_protocol_question_edit: "Volver a editar pregunta de protocolo",
  link: {
    protocol_questions: {
      disabled_link_reason: "Necesita seleccionar al menos una pregunta de protocolo para vincular.",
      page_title: "Vincular Preguntas de Protocolo Relacionadas",
      page_description:
        "Conecta Preguntas de Protocolo relacionadas para permitir el intercambio de datos entre ellas durante las evaluaciones. Las preguntas vinculadas permiten copiar respuestas de una pregunta a otra.",
      linked_items_title: "Esta pregunta de protocolo ya está vinculada a:",
    },
    requirements: {
      page_title: "Aquí puede seleccionar y vincular requisitos a esta pregunta de protocolo.",
      page_description: "Vincular los requisitos a la pregunta sobre el protocolo",
    },
  },
} as const;
